// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Reynið aftur með heilli dagsetningu eins og hér: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Hópur',
  chart_labelSeries: () => 'Röð',
  chart_labelValue: () => 'Gildi',
  checkboxSet_requiredMessageDetail: () => 'Áskilið',
  checkbox_requiredMessageDetail: () => 'Áskilið',
  close: () => 'Loka',
  collection_noData: () => 'Engin gögn til birtingar.',
  collection_selectAllRows: () => 'Velja allar raðir',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Velja röð ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Ekki raðanlegt',
  collection_sortEnabled: () => 'Raðanlegt',
  confirmation: () => 'Staðfesting',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' af ' + p['totalCount'],
  dataVisualization_noData: () => 'Engin gögn til birtingar',
  dataVisualization_stateSelected: () => 'Valið',
  dataVisualization_stateUnselected: () => 'Afvalið',
  error: () => 'Villa',
  expandableList_expandCollapseInstructionText: () => 'Notið örvalykla til að víkka og fella saman',
  expandableList_groupCollapse: () => 'Fellt saman',
  expandableList_groupExpand: () => 'Útvíkkað',
  filePicker_addFiles: () => 'Bæta skrám við',
  filePicker_dropzonePrimaryText: () => 'Draga og sleppa',
  filePicker_dropzoneSecondaryText: () => 'Veljið skrá eða sleppið skrá hér',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Veljið eða sleppið skrám hér',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ekki er hægt að hlaða upp skrám af tegundinni ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Hlaðið einni skrá upp í einu',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ekki er hægt að hlaða upp skrám af tegundinni ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'óþekkt',
  formControl_clear: () => 'Hreinsa',
  formControl_day: () => 'Dagur',
  formControl_helpAvailable: () => 'Hjálp tiltæk',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Þessum mörkum hefur verið náð ' +
    (({ one: '1 character' } as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('is').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('is').format(p['CHARACTER_LIMIT']) + ' characters') +
    '.',
  formControl_loading: () => 'Hleður',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Farið framyfir ' + p['MAX_LENGTH'] + ' hámarkslengd.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tákn eftir.',
  formControl_month: () => 'Mánuður',
  formControl_readOnly: () => 'Lesaðgangur',
  formControl_requiredMessageDetail: () => 'Skráið gildi.',
  formControl_year: () => 'Ár',
  gantt_labelDate: () => 'Dags.',
  gantt_labelEnd: () => 'Endir',
  gantt_labelLabel: () => 'Merki',
  gantt_labelRow: () => 'Röð',
  gantt_labelStart: () => 'Upphaf',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. Enginn eins hluti fannst.',
  indexer_keyboardInstructionText: () => 'Veljið skrá til að velja gildi',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Á milli ' + p['FROM_SECTION'] + ' og ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Tvísmellið og haldið til að fara í strokham, dragið síðan upp og niður til að breyta gildi.',
  info: () => 'Uppl.',
  inputDateMask_date_cleared: () => 'Uppgjörsdags.',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tómt',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'áááá',
  inputNumber_converterParseError: () => 'Skráið númer.',
  inputNumber_decrease: () => 'Minnka',
  inputNumber_increase: () => 'Auka',
  inputPassword_hidden: () => 'Aðgangsorð falið',
  inputPassword_hide: () => 'Fela aðgangsorð',
  inputPassword_show: () => 'Sýna aðgangsorð',
  list_suggestion: () => 'Tillaga',
  messageToast_allMessagesClosed: () => 'Öllum skjáskilaboðum hefur verið lokað.',
  message_close: () => 'Loka',
  message_confirmation: () => 'Lokið',
  message_error: () => 'Villa',
  message_info: () => 'Uppl.',
  message_navigationFromMessagesRegion: () =>
    'Skráningarsvæði skilaboða. Veljið F6 til að fara til baka í fyrri þátt.',
  message_navigationToMessagesRegion: () =>
    'Ný skilaboð eru á skilaboðasvæði. Veljið F6 til að fara í síðasta skilaboðasvæði.',
  message_warning: () => 'Viðvörun',
  noData_message: () => 'Ekkert til birtingar',
  overflowItemLabel: () => 'Fleiri flipar',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Í vinnslu',
  radio_helpForRadio: () => 'Hjálp fyrir valhnapp',
  radio_requiredMessageDetail: () => 'Velja gildi.',
  selectMultiple_apply: () => 'Nota',
  selectMultiple_back: () => 'Til baka',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Ýtið á bakklykil eða Delete til að fjarlægja valið gildi.',
  selectMultiple_selectedValues: () => 'Valin gildi',
  selectMultiple_showSelectedValues: () => 'Sýna eingöngu valin gildi.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) => p['VALUE_COUNT'] + ' gildi valin.',
  select_addToList: () => 'Bæta við lista',
  select_addToListAvailable: () => 'Bæta við lista tiltækt',
  select_moreSearchOptions: () => 'Fleiri leitarkostir',
  select_moreSearchOptionsAvailable: () => 'Fleiri leitarkostir tiltækir',
  select_noMatchesFound: () => 'Ekkert samsvarandi fannst.',
  select_oneMatchFound: () => 'Ein samsvörun fannst',
  select_requiredMessageDetail: () => 'Velja gildi.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' samsvaranir fundust',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' eða fleiri samsvaranir fundust',
  selector_selected: () => 'Hakað í hakreit',
  selector_unselected: () => 'Ekki hakað í hakreit',
  tabBarNavigationList_removeCueText: () => 'Fjarlægjanlegt',
  timeComponent_tooltipZoomIn: () => 'Þysja inn',
  timeComponent_tooltipZoomOut: () => 'Þysja út',
  train_current: () => 'Núverandi',
  train_message_type: () => 'Tegund boða',
  train_not_visited: () => 'Ekki skoðað',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Skref ' + p['currentStep'] + ' af ' + p['numberOfSteps'],
  train_visited: () => 'Skoðað',
  userAssistance_learnMore: () => 'Nánar',
  userAssistance_required: () => 'Áskilið',
  viz_drillable: () => 'Kafanlegt',
  warn: () => 'Viðvörun'
};
export default bundle;
